export const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      document.body.appendChild(script);
    });
  };

  export const PAYMENT_SUCCESS_URL = '/Success'; // Replace with your success URL
  export const PAYMENT_FAILURE_URL = '/payment/failure'; // Replace with your failure URL
